// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-div{padding-top:180px;width:780px;text-align:center}.error-page h1{padding-top:20px;margin-bottom:40px}.error-page a,.error-page h1{text-align:center}", ""]);
// Exports
module.exports = exports;
